import { Col, Row, Image } from "react-bootstrap";
import userImg from '../../../assets/user.png'
import { useContext, useRef, useState } from 'react';
import { ProfileContext } from '../../../pages/Profile';
import { useSelector } from "react-redux";

export default function Avatar() {

  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const { profile, getProfile } = useContext(ProfileContext)
  const [isHovered, setIsHovered] = useState(false);
  const fileInputRef = useRef(null);

  const canEdit = authUser.user.acl === 'Officer' || authUser.user._id === profile._id;

  const handleCameraClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === "image/png") {
      const formData = new FormData();
      formData.append("avatar", file);

      try {
        const response = await fetch(`${url}/users/avatar/${profile._id}`, {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${authUser.token}`,
          },
          body: formData,
        });

        if (response.ok) {
          // Refresh profile/avatar using context
          if (typeof getProfile === 'function') {
            await getProfile();
          }
        } else {
          console.error("Upload failed");
        }
      } catch (err) {
        console.error("Error uploading avatar:", err);
      }
    } else {
      alert("Only PNG files are allowed.");
    }
  };

  return (
    <Row className='avatar'>
      <Col
        className='hexagon'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ position: 'relative' }}
      >
        {!profile.avatar
          ? <Image src={userImg} style={{ marginTop: '10px', marginLeft: '10px', height: '180px', width: '180px' }} />
          : <Image src={'data:image/png;base64, ' + profile.avatar} />
        }

        {canEdit && isHovered && (
          <>
            <div style={{
              position: 'absolute',
              top: '75%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              alignItems: 'center',
              zIndex: 2
            }}>
              <i
                className="bi bi-camera"
                style={{
                  position: 'absolute',
                  top: '80%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '2rem',
                  color: '#fff',
                  cursor: 'pointer',
                  background: 'rgba(0,0,0,0.5)',
                  borderRadius: '50%',
                  padding: '10px 17px'
                }}
                onClick={handleCameraClick}
              />
              <div
                style={{
                  // height: '2.75rem', // match <i> height
                  width: '100%',
                  background: 'rgba(0,0,0,0.7)',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  // marginLeft: '100px',
                  marginTop: '-150%',
                  borderRadius: '8px'
                }}
              >
                Only squared PNG files will work. Preferably backgroundless.
              </div>
            </div>
            <input
              type="file"
              accept="image/png"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </>
        )
        }
      </Col >
    </Row >
  )
}